import React from 'react';
import "./BlogSongs.css";

function BlogSongBox({ trackId }) {
  return (
    <div className="blogSongBox">
      <div className="blogSongContent">
        {/* Spotify Embed */}
        <iframe
          data-testid="embed-iframe"
          style={{ borderRadius: '12px', border: '0' }}
          src={`https://open.spotify.com/embed/track/${trackId}?utm_source=generator`}
          width="100%"
          height="352"
          allowFullScreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
          title={`Spotify track ${trackId}`}
        />
      </div>
    </div>
  );
}

export default BlogSongBox;
